import React from 'react';
import seo from './../assets/SEO.png';
import ant from './../assets/ant.png';
import Navbar from './Navbar';


const Hero = () => {
  return (
    <div className=' pb-20 hero-container'>
       <Navbar />
        <div className='text-center mt-10'>
            <img className='m-auto' src={seo} alt='SEO' />
        </div>
        <div className='text-center mt-10 px-10'>
            <h1 className="text-center font-extrabold text-[80px] font-['Mulish']">Reimagine The Role Of <br /><span className='text-[#52BD95]'>Social Proof</span> In Your <br /> Business</h1>
            <p className='text-xl text-[#3f3f3f] py-2'><span className='text-[#6b10ff]'>20%</span> increase in sales by first month gauranteed</p>
            <p className='text-xl text-[#3f3f3f]'><span className='text-[#6b10ff]'>2,000+</span> customers using our product and enojoying the result</p>     
        </div>
        <div className='flex justify-center mt-5 hero-buttons'>
            <div className='trial-button'>
            <button className='bg-[#52BD95] rounded-md text-[#ffffff] px-7 py-4 mr-5'>Start a Free Trial</button>
            </div>
            <div className='flex bg-[#1B1139] py-4 px-7 rounded-md howItWorks-btn'>
                <img className='pr-1' src={ant} alt='Img' />
                <button className='text-[#52BD95]'>See How It Works</button>
            </div>
        </div>

    </div>
  )
}

export default Hero